import React, { useEffect, useState, useRef } from 'react'
import { postContact } from './data/BugData';
// Implement validation in both ask and answer forms
import { Form, required, minLength, emailValidator, Values } from './Form';
import { Field } from './Field';

import { postContactForm } from '../../../services/BugReport';
import autoAnimate from '@formkit/auto-animate'


export const BugReportWidget = ({ open, setOpen }) => {

  const modalAnimate = useRef(null)

  useEffect(() => {
    modalAnimate.current && autoAnimate(modalAnimate.current)
  }, [modalAnimate])

  const onCancelClick = () => {
    setOpen(false)
  }

  // Lets implement the submit handler
  const handleSubmit = async (values: Values) => {
    const content = await postContact({
      name: values.ContactName,
      email: values.ContactEmail,
      message: values.Content,
      created: new Date(),
    });
    // modalAnimate.current.reset();
    if (content != null) {
      const formData = new FormData();
      formData.append('data', JSON.stringify({
        ContactName: values.ContactName,
        ContactEmail: values.ContactEmail,
        Content: values.Content
      }));
      let postContactResult = await postContactForm(formData)

      // return{ success: postContactResult.status == 200 ? true : false}

      if (postContactResult.status == 200) {

        return { success: true, submitMessage: "Your contact information was successfully submitted" }

      } else {

        return { success: false, submitMessage: String(postContactResult) }

      }
    } else {
      // return { success: content ? true : false };
      return { success: false, submitMessage: "There was a problem with your content provided" }
    }
  };
  return (
    <div ref={modalAnimate} className="modal" onClick={() => setOpen(false)} style={open ? { display: 'block' } : { display: 'none' }}>
      <div className="modal__cont" onClick={(e) => e.stopPropagation()}>
        <Form submitCaption="Submit Bug Report" 
          validationRules={{
            ContactName: [{ validator: required }, { validator: minLength, arg: 10 }],
            ContactEmail: [{ validator: required }, { validator: emailValidator }],
            Content: [{ validator: required }, { validator: minLength, arg: 20 }]
          }}
          onSubmit={handleSubmit}
          failureMessage="This failure message will be overwritten"
          successMessage="This success message will overwritten"
        >
          <div style={{ marginLeft: "25rem" }}>
            <span onClick={onCancelClick} className='button button--outline button--fit button--sm'>X</span>
          </div>
          <h2 className="title">Submit a Bug Report</h2>
          <Field name="ContactName" label="Name" />
          <Field name="ContactEmail" label="Email" />
          <Field name="Content" label="Message" type="TextArea" />
        </Form>
      </div>
    </div>

  );
}

export default BugReportWidget